// ** Icon imports
import HomeIcon from 'mdi-material-ui/Home'
import Sidemenuicon from 'src/assets/svgs/sidemenuicon.svg'

const navigation = () => {
  return [
    {
      sectionTitle: 'menu'
    },
    {
      title: 'overview',
      icon: Sidemenuicon,
      path: '/overview'
    },
    {
      title: 'business subscription',
      icon: Sidemenuicon,
      path: '/business-subscription'
    },
    {
      title: 'fast marketing',
      icon: Sidemenuicon,
      path: '/fast-marketing'
    },
    {
      title: 'operator wallet',
      icon: Sidemenuicon,
      path: '/operator-wallet',
      children: [
        {
          title: 'new wallets',
          icon: false,
          path: '/operator-wallet'
        },
        {
          title: 'top-ups',
          path: '/operator-wallet'
        },
        {
          title: 'in-app transactions',
          path: '/operator-wallet'
        },
        {
          title: 'deactivated wallets',
          path: '/operator-wallet'
        }
      ]
    },
    {
      title: 'personal wallet',
      icon: Sidemenuicon,
      path: '/personal-wallet',
      children: [
        {
          title: 'new wallets',
          path: '/personal-wallet'
        },
        {
          title: 'top-ups',
          path: '/personal-wallet'
        },
        {
          title: 'in-app transactions',
          path: '/personal-wallet'
        },
        {
          title: 'cash-outs',
          path: '/personal-wallet'
        },
        {
          title: 'deactivated wallets',
          path: '/personal-wallet'
        }
      ]
    },
    {
      title: 'business wallet',
      icon: Sidemenuicon,
      path: '/business-wallet',
      children: [
        {
          title: 'business wallets',
          path: '/business-wallet'
        },
        {
          title: 'cash-outs limits',
          path: '/wallet-limit'
        },
        {
          title: 'cash-outs',
          path: '/business-cash-outs'
        }
      ]
    },
    {
      sectionTitle: 'general'
    },
    {
      title: 'tax settings',
      icon: Sidemenuicon,
      path: '/tax-settings'
    },
    {
      title: 'tier settings',
      icon: Sidemenuicon,
      path: '/tier-settings'
    },
    {
      title: 'ad settings',
      icon: Sidemenuicon,
      path: '/ad-settings'
    },
    {
      title: 'bank settings',
      icon: Sidemenuicon,
      path: '/bank-settings'
    },
    {
      title: 'currency',
      icon: Sidemenuicon,
      path: '/currency-settings'
    },
    // {
    //   title: 'Demo',
    //   icon: GroupIcon,
    //   children: [
    //     {
    //       icon: PersonIcon,
    //       title: 'Demo 1',
    //       path: '/demo1'
    //     },
    //     {
    //       icon: PersonIcon,
    //       title: 'Demo 2',
    //       path: '/demo2'
    //     },
    //     {
    //       icon: PersonIcon,
    //       title: 'Demo 3',
    //       path: '/demo3'
    //     }
    //   ]
    // },
    // {
    //   title: 'Title 2',
    //   icon: MedicalInformationIcon,
    //   path: '/medical-specialization'
    // },
    // {
    //   title: 'Title 3',
    //   icon: AutoAwesomeMotionIcon,
    //   path: '/provider-type'
    // },
    // {
    //   sectionTitle: 'Section Title'
    // },
    // {
    //   title: 'Title 4',
    //   icon: AutoAwesomeMotionIcon,
    //   path: '/plan-services'
    // },
    // {
    //   title: 'Title 5',
    //   icon: CogIcon,
    //   path: '/complimentary-services'
    // },
    // {
    //   title: 'Title 6',
    //   icon: WebStoriesIcon,
    //   path: '/plan-packages'
    // },
    // {
    //   title: 'Title 7',
    //   icon: CogIcon,
    //   path: '/subscription-plans'
    // },
    // {
    //   sectionTitle: 'Section Title'
    // },
    // {
    //   title: 'Title 8',
    //   icon: CogIcon,
    //   path: '/settings'
    // }
  ]
}

export default navigation
